const BASE_URL = 'https://api.tvfm.digitaltriumph.co.in/api/';

export const getData = async (url, params, token) => {
    try {
        let apiUrl = `${BASE_URL}${url}`;
        if (params) {
            const queryParams = new URLSearchParams();
            Object.keys(params).forEach(key => {
                if (params[key] !== null && params[key] !== undefined && params[key] !== '') {
                    queryParams.append(key, params[key]);
                }
            });
            const queryString = queryParams.toString();
            if (queryString) {
                apiUrl += `?${queryString}`;
            }
        }
        
        const headers = {
            'Content-Type': 'application/json',
        };
        if (token) headers['Authorization'] = token;

        const response = await fetch(apiUrl, {
            method: 'GET',
            headers: headers
        });

        if (!response.ok) {
            const errorData = await response.json().catch(() => ({}));
            throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error('API Error:', error);
        throw error;
    }
};

export const postData = async (url, data, token) => {
    try {
        const headers = {
            'Content-Type': 'application/json',
        };
        if (token) headers['Authorization'] = token;

        const response = await fetch(`${BASE_URL}${url}`, {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(data)
        });

        const resData = await response.json();
        
        if (!response.ok) {
            throw new Error(resData.message || `HTTP error! status: ${response.status}`);
        }

        return resData;
    } catch (error) {
         console.error('API Error:', error);
         throw error;
    }
};

export const putData = async (url, data, token) => {
    try {
        // Check if data is FormData; if so, do NOT set Content-Type header (browser sets it with boundary)
        const isFormData = data instanceof FormData;
        const headers = {};
        if (!isFormData) {
            headers['Content-Type'] = 'application/json';
        }
        if (token) headers['Authorization'] = token;

        const response = await fetch(`${BASE_URL}${url}`, {
            method: 'PUT',
            headers: headers,
            body: isFormData ? data : JSON.stringify(data)
        });

        const resData = await response.json();

        if (!response.ok) {
            throw new Error(resData.message || `HTTP error! status: ${response.status}`);
        }
        
        return resData;
    } catch (error) {
         console.error('API Error:', error);
         throw error;
    }
};

export const deleteData = async (url, token) => {
    try {
        const headers = {
            'Content-Type': 'application/json',
        };
        if (token) headers['Authorization'] = token;

        const response = await fetch(`${BASE_URL}${url}`, {
            method: 'DELETE',
            headers: headers
        });

        const resData = await response.json();

        if (!response.ok) {
             throw new Error(resData.message || `HTTP error! status: ${response.status}`);
        }

        return resData;
    } catch (error) {
         console.error('API Error:', error);
         throw error;
    }
};

export const postFileUpload = async (url, data, token) => {
    try {
        // For FormData, do not set 'Content-Type' manually
        const headers = {};
        if (token) headers['Authorization'] = token;

        const response = await fetch(`${BASE_URL}${url}`, {
            method: 'POST',
            headers: headers,
            body: data
        });

        const resData = await response.json();

        if (!response.ok) {
            throw new Error(resData.message || `HTTP error! status: ${response.status}`);
        }

        return resData;
    } catch (error) {
         console.error('API Error:', error);
         throw error;
    }
};
